import axios from "../axios";

export const downloadMonthlyReport = async (year, month) => {
  return axios.get(
    `/api/Task/MonthlyReport?Year=${year}&Month=${month}`,
    {
      responseType: "blob",
    }
  );
};

export const getUserYearlyTaskReport = async (payload) => {
  return axios.post("/api/Report/User/YearlyTaskReport", payload);
};
